<template>
  <v-dialog v-model="isSelectLauguageDialog" max-width="400">
    <template v-slot:activator="{ attrs }">
      <v-row no-gutters class="container-btn">
        <v-tooltip top color="#131b1e">
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              :plain="plain ? true : false"
              :color="basicBtnColor ? basicBtnColor : 'rgb(22, 29, 33)'"
              v-bind="attrs"
              v-on="on"
              @click="openDialog"
              class="btn-select-language"
              elevation="0"
              :disabled="isTranscriptDisabled || isClOrganizer === false"
              :style="basicBtnFontColor ? 'color: ' + basicBtnFontColor : 'color: #ddd'"
            >
              <span
                v-if="basicBtnIcon"
                class="material-icons-round mr-1 btn-span"
                :style="basicBtnIconColor ? 'color: ' + basicBtnIconColor : 'color: #ddd'"
                translate="no"
              >
                {{ basicBtnIcon }}
              </span>
              {{ basicBtnName ? basicBtnName : selectedLanguage ? selectedLanguage : 'Auto Detect' }}
            </v-btn>
          </template>
          <span>Select Language</span>
        </v-tooltip>
      </v-row>
    </template>
    <v-card class="container-card px-7 py-5" color="#21343b" width="auto">
      <v-row no-gutters align="center" justify="center">
        <v-col cols="12" class="title">{{ 'Select a language' }}</v-col>
        <v-col cols="12" class="subtitle mt-1">
          {{ subTitle ? subTitle : 'Choose the target language into which you want to translate the transcript.' }}
        </v-col>
      </v-row>
      <v-row no-gutters align="center" justify="center">
        <v-col class="px-5 mt-4 container-selected" :cols="12" align="start" justify="center" style="display: none">
          {{
            selectedLanguage ? selectedLanguage : initialLanguage ? initialLanguage : autoDetect ? 'Auto Detect' : ''
          }}
        </v-col>
        <!-- <v-col cols="12" v-if="error1" class="mt-2 px-2" style="font-size: 12px; color: #ff464f">
          {{ 'The language is the same as before. Please choose a different language.' }}
        </v-col> -->

        <v-col class="my-4" align="start" justify="center">
          <div class="container-language">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="mb-3 search"
              solo
              flat
              dark
            ></v-text-field>
            <div class="list-language">
              <v-list v-for="item in filteredItems" :key="item.data">
                <v-col cols="12" style="padding: 0" @click="clickItem(item)">
                  <span
                    class=""
                    :style="
                      selectedLanguage
                        ? selectedLanguage === item.label
                          ? 'color: #289067'
                          : ''
                        : initialLanguage
                        ? initialLanguage === item.label
                          ? 'color: #289067'
                          : ''
                        : ''
                    "
                  >
                    {{ item.label }}
                  </span>
                </v-col>
              </v-list>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters align="center" justify="center">
        <v-col cols="12" class="container-btn mt-1" align="end">
          <v-btn dark class="btn-done" elevation="0" :disabled="initialLanguage === selectedLanguage" @click="submit">
            <span v-if="btnIcon" class="material-icons-round mr-1" translate="no">{{ btnIcon }}</span>
            {{ btnName }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SelectLanguage',
  props: {
    plain: Boolean, // 외부 버튼 형태
    autoDetect: Boolean, // 외부 버튼 텍스트를 autoDetect로 할 것인지
    isClOrganizer: Boolean, // 클립 생성자인지 정보
    isTranscriptDisabled: Boolean, // record preview에서 30초 disabled 받아오는 값
    btnName: String, // 모달 내부 확인 버튼 텍스트
    btnIcon: String, // 모달 내부 확인 버튼 아이콘
    basicBtnName: String, // 외부 버튼 텍스트
    basicBtnColor: String, // 외부 버튼 색상
    basicBtnFontColor: String, // 외부 버튼 텍스트 색상
    basicBtnIcon: String, // 외부 버튼 아이콘
    basicBtnIconColor: String, // 외부 버튼 아이콘 색상
    subTitle: String, // 중간 제목
    initialLanguage: String,
  },
  data() {
    return {
      isSelectLauguageDialog: false,
      selectedLanguage: null,
      search: '',
      searchItem: [],
      languageList: [
        { label: 'English', data: 'en' },
        { label: 'Spanish', data: 'es' },
        { label: 'Korean', data: 'ko' },
        { label: 'French', data: 'fr' },
        { label: 'German', data: 'de' },
        { label: 'Italian', data: 'it' },
        { label: 'Portuguese', data: 'pt' },
        { label: 'Dutch', data: 'nl' },
        { label: 'Chinese', data: 'zh' },
        { label: 'Japanese', data: 'ja' },
        { label: 'Arabic', data: 'ar' },
        { label: 'Hindi', data: 'hi' },
        { label: 'Bengali', data: 'bn' },
        { label: 'Urdu', data: 'ur' },
        { label: 'Turkish', data: 'tr' },
        { label: 'Polish', data: 'pl' },
        { label: 'Romanian', data: 'ro' },
        { label: 'Swedish', data: 'sv' },
        { label: 'Norwegian', data: 'no' },
        { label: 'Danish', data: 'da' },
        { label: 'Finnish', data: 'fi' },
        { label: 'Greek', data: 'el' },
        { label: 'Hungarian', data: 'hu' },
        { label: 'Indonesian', data: 'id' },
        { label: 'Malay', data: 'ms' },
        { label: 'Thai', data: 'th' },
        { label: 'Vietnamese', data: 'vi' },
        { label: 'Czech', data: 'cs' },
        { label: 'Slovak', data: 'sk' },
        { label: 'Slovenian', data: 'sl' },
        { label: 'Croatian', data: 'hr' },
        { label: 'Serbian', data: 'sr' },
        { label: 'Ukrainian', data: 'uk' },
        { label: 'Bulgarian', data: 'bg' },
        { label: 'Catalan', data: 'ca' },
        { label: 'Latvian', data: 'lv' },
        { label: 'Lithuanian', data: 'lt' },
        { label: 'Estonian', data: 'et' },
        { label: 'Albanian', data: 'sq' },
        { label: 'Macedonian', data: 'mk' },
        { label: 'Persian', data: 'fa' },
        { label: 'Swahili', data: 'sw' },
        { label: 'Tamil', data: 'ta' },
        { label: 'Telugu', data: 'te' },
        { label: 'Kannada', data: 'kn' },
        { label: 'Marathi', data: 'mr' },
        { label: 'Punjabi', data: 'pa' },
        { label: 'Gujarati', data: 'gu' },
      ],
      // error1: false,
    }
  },
  mounted() {
    setTimeout(() => (this.searchItem = this.languageList))
  },
  methods: {
    openDialog() {
      this.isSelectLauguageDialog = true
    },
    clickItem(item) {
      this.selectedLanguage = item.label
      // this.error1 = false
    },
    submit() {
      let languageData = this.languageList.find((language) => language['label'] === this.selectedLanguage)
      this.$emit('language', languageData)
      this.isSelectLauguageDialog = false
    },
  },
  computed: {
    ...mapGetters(['selectedCh', 'userInfo']),
    filteredItems() {
      return this.searchItem.filter((item) => {
        return item.label.toLowerCase().match(this.search.toLowerCase())
      })
    },
    currentClip() {
      return this.$store.getters.currentClip
    },
    totalSectionList() {
      return this.$store.getters.totalSectionList
    },
    sectionIndex() {
      return this.$store.getters.sectionIndex
    },
    mtInfo() {
      return this.$store.getters.currentMt
    },
    isPlayerPause() {
      return this.$store.getters.isPlayerPause
    },
  },
  watch: {
    search(val) {
      if (!val) {
        setTimeout(() => (this.searchItem = this.languageList))
      }
    },
  },
}
</script>

<style scoped>
.btn-select-language {
  border-radius: 8px;
}
.v-btn.v-btn--disabled:disabled {
  background-color: rgba(22, 29, 33, 0.4) !important;
}
.btn-select-language >>> span {
  font-size: 13px;
  font-weight: 400;
}
.v-dialog__content >>> .v-dialog {
  overflow: hidden;
}
.container-card {
  border-radius: 10px;
}
.container-selected {
  display: flex;
  align-items: center;
  height: 50px;
  background-color: #1a272e;
  border-radius: 5px;
  color: #eee;
  font-size: 15px;
  font-weight: 500;
}
.container-language {
  padding: 20px;
  font-size: 13px;
  height: auto !important;
  background-color: #1a272e;
  border-radius: 5px;
}
.container-language .v-list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  background-color: #1a272e;
  color: #ccc;
  font-size: 15px !important;
  cursor: pointer;
  padding-left: 5px;
}
.container-language .v-list:hover {
  color: #fff;
}
.container-language .list-language {
  height: 200px;
  overflow-x: hidden;
  overflow-y: auto;
}
.title {
  color: #eee;
  font-size: 20px !important;
  font-weight: 500;
}
.subtitle {
  font-size: 13px;
  color: #96a7af;
}
.search >>> .v-input__slot {
  background-color: #21343b !important;
}
.search >>> .v-label {
  font-size: 14px;
  color: #96a7af;
}
button.btn-done {
  background-color: rgb(40, 144, 103) !important;
  border-radius: 3px;
}
button.btn-done >>> span {
  font-size: 14px;
  font-weight: 500;
}
</style>
